import ContextualBarAPI from './contextual-bar-api';

export default ContextualBarAPI;
